import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "reports",
  "use": "reports-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" id=\"reports\"><path d=\"M287.918 96c.209-35.38 28.937-64 64.355-64H672v192.061C672 259.626 700.739 288 736.189 288H896v544.082C896 867.49 867.383 896 832.082 896c-.209 35.38-28.777 64-64 64-.209 35.38-28.777 64-64 64H223.917c-35.408 0-63.918-28.759-63.918-64.235V224.234c0-35.488 28.617-64.235 63.918-64.235.082-35.253 28.699-64 64-64zM224 895.765L223.999 192C206.327 192 192 206.568 192 223.855v736.291c0 17.593 14.551 31.855 31.999 31.855h480.003c17.672 0 31.999-14.568 31.999-31.855l-448.082-.145c-35.408 0-63.918-28.759-63.918-64.235zm32-735.91v736.291c0 17.593 14.551 31.855 31.999 31.855h480.003c17.672 0 31.999-14.568 31.999-31.855l-448.082-.145c-35.408 0-63.918-28.759-63.918-64.235V128.001c-17.674 0-32 14.568-32 31.855zM704 32v191.906C704 241.631 718.431 256 735.705 256H896L704 32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/reports.svg
// module id = 7Qnc
// module chunks = 1